import ComposeMail from "../../mixins/compose-mail";
import ArchiveMixin from "../../mixins/archiving-mixin";

Vue.component("view-service-provider", {

    mixins: [ArchiveMixin, ComposeMail],

    props: {
        serviceProvider: {},
    },

    data () {
        return {
            mutableServiceProvider: {}
        };
    },

    computed: {
        contactsUrl () {
            return "/contacts/serviceprovider/" + this.mutableServiceProvider.id;
        },
        ticketsUrl () {
            return "/serviceproviders/" + this.serviceProvider.id + "/tickets";
        }
    },

    created () {
        this.mutableServiceProvider = this.serviceProvider;
    },

    methods: {
        goToTicket (ticketId) {
            window.location = "/tickets/" + ticketId;
        },

        afterArchiving (archiving) {
            if (archiving) {
                this.mutableServiceProvider.archived_at = this.$dayjs();
                window.location = "/serviceproviders";
            } else {
                this.mutableServiceProvider.archived_at = null;
            }
        },
    },
});
